(function () {
	"use strict";

	function initLanding(root) {
		if (!root || root.__tupLandingReady) return;
		root.__tupLandingReady = true;

		const sticky = root.querySelector("[data-tup-sticky]");
		const hero = root.querySelector("[data-tup-hero]");
		const stickyButtons = sticky
			? Array.prototype.slice.call(sticky.querySelectorAll("button, a"))
			: [];
		const revealItems = Array.prototype.slice.call(
			root.querySelectorAll(".tup-reveal"),
		);
		const beforeAfterComparisons = Array.prototype.slice.call(
			root.querySelectorAll("[data-before-after]"),
		);

		beforeAfterComparisons.forEach(function (comparison) {
			const stage = comparison.querySelector("[data-before-after-stage]");
			const range = comparison.querySelector("[data-before-after-range]");
			if (!stage || !range) return;

			function updateComparison() {
				stage.style.setProperty("--after-width", range.value + "%");
			}

			range.addEventListener("input", updateComparison);
			updateComparison();
		});

		function updateSticky() {
			if (!sticky || !hero) return;
			const trigger = hero.offsetTop + hero.offsetHeight * 0.55;
			const visible = window.scrollY > trigger;
			sticky.classList.toggle("is-visible", visible);
			sticky.setAttribute("aria-hidden", visible ? "false" : "true");
			stickyButtons.forEach(function (button) {
				button.tabIndex = visible ? 0 : -1;
			});
		}

		if ("IntersectionObserver" in window) {
			const observer = new IntersectionObserver(
				function (entries) {
					entries.forEach(function (entry) {
						if (!entry.isIntersecting) return;
						entry.target.classList.add("is-visible");
						observer.unobserve(entry.target);
					});
				},
				{ threshold: 0.14 },
			);
			revealItems.forEach(function (item, index) {
				item.style.transitionDelay = Math.min(index * 45, 220) + "ms";
				observer.observe(item);
			});
		} else {
			revealItems.forEach(function (item) {
				item.classList.add("is-visible");
			});
		}

		Array.prototype.slice
			.call(root.querySelectorAll("[data-tup-faq] details"))
			.forEach(function (detail) {
				detail.addEventListener("toggle", function () {
					if (!detail.open) return;
					Array.prototype.slice
						.call(root.querySelectorAll("[data-tup-faq] details"))
						.forEach(function (other) {
							if (other !== detail) other.open = false;
						});
				});
			});

		root.addEventListener("click", function (event) {
			const trigger =
				event.target && event.target.closest
					? event.target.closest("[data-tuf-open]")
					: null;
			if (!trigger || !root.contains(trigger)) return;
			document.dispatchEvent(
				new CustomEvent("partify:touchup-landing:cta", {
					detail: { label: (trigger.textContent || "").trim() },
				}),
			);
			if (!document.querySelector("[data-tuf-root]")) {
				event.preventDefault();
				window.location.href = "/collections/touch-up-paint?tuf=open";
			}
		});

		updateSticky();
		window.addEventListener("scroll", updateSticky, { passive: true });
		window.addEventListener("resize", updateSticky);
	}

	function boot() {
		Array.prototype.slice
			.call(document.querySelectorAll("[data-touchup-landing]"))
			.forEach(initLanding);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", boot);
	} else {
		boot();
	}
})();
